import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import Page from '@cobliteam/ui-business/components/layout/Page';
import PathAssociationTable from '../components/PathAssociationTable';
import FaceRecognitionBanner from '../components/PathAssociationTable/components/FaceRecognitionBanner';

const PathAssociationPage = () => {
  const { runtimeFlags } = useDashboard();

  return (
    <Page>
      <Page.Header>
        <Page.Title />
      </Page.Header>

      <Page.Body>
        {runtimeFlags.hasCameraFlag && <FaceRecognitionBanner />}
        <PathAssociationTable />
      </Page.Body>
    </Page>
  );
};

export default PathAssociationPage;
